import React from 'react';
import { Pressable, Text, View } from 'react-native';

import { palette } from '@/config/theme';
import { recordError } from '@/lib/analytics/firebase';

/**
 * Last-resort crash guard: catches any render error below it and shows a branded
 * recovery screen with a Retry reset, instead of the app white-screening. Built
 * from React Native primitives + static palette only (no fonts/i18n/providers),
 * so the fallback itself can never be the thing that fails.
 */
export class ErrorBoundary extends React.Component<
  { children: React.ReactNode },
  { hasError: boolean }
> {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: unknown) {
    console.error('[ErrorBoundary]', error);
    // Report the crash to Crashlytics (Android build only; no-op elsewhere).
    recordError(error);
  }

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <View
        style={{
          flex: 1,
          alignItems: 'center',
          justifyContent: 'center',
          padding: 32,
          backgroundColor: palette.gradBottom,
        }}
      >
        <Text
          style={{
            color: palette.text,
            fontSize: 20,
            fontWeight: '700',
            textAlign: 'center',
            marginBottom: 10,
          }}
        >
          حصلت مشكلة بسيطة
        </Text>
        <Text
          style={{ color: palette.soft, fontSize: 14, textAlign: 'center', marginBottom: 24 }}
        >
          Something went wrong. Please try again.
        </Text>
        <Pressable
          accessibilityRole="button"
          onPress={() => this.setState({ hasError: false })}
          style={{
            backgroundColor: palette.volt,
            paddingHorizontal: 28,
            paddingVertical: 12,
            borderRadius: 999,
          }}
        >
          <Text style={{ color: palette.onVolt, fontWeight: '700' }}>إعادة المحاولة · Retry</Text>
        </Pressable>
      </View>
    );
  }
}
